"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemCurrencyField = void 0;
var QuoteLineItemContext_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteLineItem/QuoteLineItemContext");
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var assertUnreachable_1 = require("@CommonFrontendBackend/Utils/assertUnreachable");
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var QuoteLineItemCurrencyField = function (_a) {
    var field = _a.field;
    var currencyFormatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    var item = (0, QuoteLineItemContext_1.useQuoteLineItemContext)().item;
    if (field.strategy === "fixed") {
        return react_1.default.createElement("div", null, currencyFormatter.format(field.value));
    }
    else if (field.strategy === "volume") {
        var controllingField = item.customFields.find(function (f) { return f.id === field.controllingFieldId && f.type === "number"; });
        (0, tiny_invariant_1.default)(!!controllingField, "controlling field couldn't be found in custom fields");
        var value = (0, Helpers_1.getVolumeStrategyValue)(field, controllingField.value);
        return react_1.default.createElement("div", null, currencyFormatter.format(value));
    }
    return (0, assertUnreachable_1.assertUnreachable)(field);
};
exports.QuoteLineItemCurrencyField = QuoteLineItemCurrencyField;
